<div class="page-header">
  <div class="page-header-title">{{ 'title.tournaments' | translate }}</div>
  <div class="page-header-search flex gap-2">
    <app-search-field></app-search-field>
    @if(authService.hasRole(['admin', 'staff'])) {
      <p-button icon="pi pi-plus" class="add-button add-button-white" rounded (click)="addTournament()" 
        [pTooltip]="'button.new-tournament' | translate" tooltipPosition="top" />
    }
    @if(isDev) {
      <p-button icon="pi pi-plus" class="add-button" rounded (click)="addTournamentDev()" 
        [pTooltip]="'button.new-tournament-dev' | translate" tooltipPosition="top" [loading]="loadingTournamentDev" />
    }
  </div>
</div>
<p-menubar [model]="items" class="p-menubar-secondary">
  <ng-template #item let-item>
    <a [routerLink]="item.route" class="p-menubar-item-link" 
      [ngClass]="{'p-menubar-item-link-active': item.isActive()}">
      <span>{{ item.label }}</span>
    </a>
  </ng-template>
</p-menubar>
<div class="wrapper">
  <router-outlet />
</div>
